import {Logout} from '@mui/icons-material';
import * as React from 'react';
import {logoutOperator} from '../utils/LoginApi';
import PropTypes from 'prop-types';
import {useLoading} from '../../loading-overlay/LoadingContext';
import {toast} from 'react-toastify';

export default function OperatorLogout({onLogoutAttempt}) {
  const {addToLoading} = useLoading();

  const doLogoutOperator = async () => {
    const logoutPromise = logoutOperator();
    addToLoading(logoutPromise);
    const response = await logoutPromise;
    if (response.status === 200) {
      toast.success('Logout Successful');
    } else {
      toast.error('Logout Failed');
    }
    onLogoutAttempt();
  };

  return <Logout onClick={doLogoutOperator} sx={{color: '#081d25'}}/>;
}

OperatorLogout.propTypes = {
  onLogoutAttempt: PropTypes.func.isRequired,
};
